
class Reference {
  constructor() {
    this.hideOrShowMouse();
    // this.onMouseClick();
  }

  // onMouseClick() {
  //   const mouse = window.wrapper.querySelector('.reference__mouse');

  //   mouse.addEventListener('click', () => {
  //     window.smoothScroll.scrollTo('section:nth-child(2)');
  //   });
  // }

  hideOrShowMouse() {
    const hero = window.wrapper.querySelector('.reference__hero');
    this.lastScrollTop = 0;

    this.checkMenuState = () => {
      const delta = window.scrollY;

      if (delta > 5) {
        hero.classList.add('scrolling');
      } else {
        hero.classList.remove('scrolling');
      }

      this.lastScrollTop = delta;
    };
    this.checkMenuState();

    window.addEventListener('scroll', this.checkMenuState);
  }
}

export default Reference;
